import React, { Component, Fragment } from 'react'
import type { Element } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import type { IntlShape } from 'react-intl'
import styled from 'styled-components'
import { media } from 'app/assets/styles'
import { CaptionText, Text } from 'app/common/typography'
import type { RestaurantShortDTO } from 'shared/types'
import { AddFavoriteRestaurant } from 'app/kingdom/profile/favorite-restaurant/add-favorite-restaurant'
import { colors } from 'shared/assets/styles'
import { CirclePencil, CirclePlus, Pin } from 'app/assets/icons'
import { removeLocalitiesContainerFromDOM } from 'app/common/utils'

const { grey, text } = colors

type Props = {
    favRestaurant: RestaurantShortDTO,
    onClick?: (selectedRestaurant: RestaurantShortDTO) => void,
    title: Element<any>,
    intl: IntlShape
}

type State = {
    openedAddRestaurantModal: boolean,
    restaurantId: ?string
}

class FavoriteRestaurantComponent extends Component<Props, State> {
    state = {
        restaurantId: null,
        openedAddRestaurantModal: false
    }

    openAddRestaurantModal = () =>
        this.setState({ openedAddRestaurantModal: true })

    closeAddRestaurantModal = () => {
        this.setState({
            openedAddRestaurantModal: false
        })
        removeLocalitiesContainerFromDOM()
    }

    render() {
        const { favRestaurant, title, onClick } = this.props
        const { openedAddRestaurantModal } = this.state
        const { name, addressFull } = favRestaurant || {}
        return (
            <Fragment>
                {title}
                {favRestaurant ? (
                    <Container>
                        <RestaurantContainer>
                            <PinContainer>
                                <Pin />
                            </PinContainer>
                            <RestaurantInfos>
                                <Text>{name}</Text>
                                <CaptionText>{addressFull}</CaptionText>
                            </RestaurantInfos>
                        </RestaurantContainer>
                        <StyledCirclePencil
                            color={text}
                            onClick={this.openAddRestaurantModal}
                        />
                    </Container>
                ) : (
                    <AddRestaurantButton
                        onClick={this.openAddRestaurantModal}
                        type="button">
                        <CirclePlus color={grey} stroke={grey} small />
                        <Text color={grey}>
                            <FormattedMessage id="kingdom.profile.form.restaurant.button.add" />
                        </Text>
                    </AddRestaurantButton>
                )}
                <AddFavoriteRestaurant
                    isOpen={openedAddRestaurantModal}
                    handleClose={this.closeAddRestaurantModal}
                    onClick={onClick}
                />
            </Fragment>
        )
    }
}

const Container = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    margin-top: 10px;
    flex-direction: row;
    justify-content: space-between;
`

const RestaurantContainer = styled.div`
    display: flex;
    align-items: center;
    ${media.medium`
        width: calc(50% - 10px);
    `};
`

const StyledCirclePencil = styled(CirclePencil)`
    margin-left: 10px;
`

const PinContainer = styled.div`
    margin-right: 5px;
    position: relative;
`

const AddRestaurantButton = styled.button`
    display: flex;
    flex-direction: row;
    align-items: center;
    border: solid 1px ${grey};
    border-radius: 10px;
    margin-top: 5px;
    background-color: white;
    padding-right: 15px;
    width: 100%;
    ${media.medium`
        width: 250px;
    `}
`

const RestaurantInfos = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    padding-left: 10px;
`

const FavoriteRestaurant = injectIntl(FavoriteRestaurantComponent)

export { FavoriteRestaurant }
